<template>
    <div
        class="content-video-header"
        :class="{
            'video-enabled rounded-b-lg': !!videoSrc
        }"
    >
        <!-- Background Video -->
        <video
            v-if="videoSrc"
            class="fill-width fill-height"
            autoplay
            muted
            loop
            playsinline
        >
            <source
                :src="videoSrc"
                type="video/mp4"
            >
            <track kind="captions">
        </video>

        <!-- Header Content -->
        <div class="slot-header">
            <slot />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { useIsMobile } from '~/composables';
    import type { BannerVideo } from '~/types';

    const props = defineProps({
        bannerVideo: {
            type: Object as PropType<BannerVideo>,
            required: true
        }
    });

    const { isMobile } = useIsMobile();
    const videoSrc = computed<Nilish<string>>(() => isMobile.value ? props.bannerVideo.mobile ?? null : props.bannerVideo.desktop ?? null);
</script>

<style lang="scss">
.content-video-header {
    transition: all 0.5s ease-in-out;

    &.video-enabled {
        position: relative;
        padding-bottom: 22vh;
        overflow: hidden;
        background-color: #000;

        video {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            margin: auto;
            width: 100%;
            height: 100%;
            object-position: center center;
            object-fit: cover;
        }

        // Header Content
        .slot-header {
            filter: opacity(0.9);
            color: #fff;
            padding: 1rem 1.2rem 0 2rem;
            
            h1 {
                filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.5));
            }

            .page-title {
                margin-top: -0.4rem;
            }

            a {
                display: inline-block;
                line-height: 1;
                width: fit-content;
                text-decoration: none;
                color: #000;
                background-color: #fff;
                padding: 0.3rem 1.1rem;
                border-radius: 40px;
                font-size: 70%;
            }
        }
        
        .video-toggle {
            filter: invert(1);
            position: absolute;
            bottom: 0;
            right: 0;
            z-index: 1;
        }
    }
}
</style>
